import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import settings from '../../constants/constants';

const footer = (props) => {
  return (
    <Container className={`footer row m-0 p-0 align-items-center ${props.isSignin ? 'bg-transparent' : ''}`}>
      <Row className='wrap align-items-center p-0'>
        <Col className='text-start p-0'>
          <div data-testid='footer-copyrights'>
            Copyrights Reserved <span className="fw-bold">Leafio</span>
          </div>
        </Col>
        <Col className='text-end p-0'>
          <div data-testid='footer-support-number'>Service Support Number: {settings.supportInfo.number}</div>
        </Col>
      </Row>
    </Container>
  );
};

export default footer;
